import $ from 'jquery/dist/jquery';
window.$ = window.jQuery = $;

$.validate = require('jquery-validation/dist/jquery.validate');
$.validator.unobtrusive = require('jquery-validation-unobtrusive');

// require('./libraries/customFileUpload');